module.exports = __webpack_public_path__ + "img/ai-task-generation.dd319a4f.svg";